module.exports = __webpack_public_path__ + "pnskfsquadron/img/fb-tw.jpg?f30ee555";